import { OverAllChapter } from './OverAllChapter'
import { withOverAllChapter } from './withOverAllChapter'

const ConnectedOverAllChapter = withOverAllChapter(OverAllChapter)

export { ConnectedOverAllChapter as OverAllChapter }
